import React from "react";
import { Bar } from "react-chartjs-2";

export const ChartBar = ({ title, total, lastUpdate, data }) => {
    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: "top",
            },
            title: {
                display: false,
                text: "Permisos",
            },
        },
    };

    return (
        <div className="card mb-3 mt-3 card--reportes mx-auto">
            <div className="header-info">
                <h6 className="font-weight-bold m-0">{title}</h6>
            </div>
            <div className="chart-details">
                <p className="total-title">{total}</p>
                <p className="update-info">{lastUpdate}</p>
            </div>
            <div className="card-body">
                <Bar data={data} options={options} height={115} />
            </div>
        </div>
    );
};
